var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_712_3530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70828 7.16672H1.45828C0.654144 7.16672 0 6.51257 0 5.70828V1.95828C0 1.15414 0.654144 0.5 1.45828 0.5H7.70828C8.51257 0.5 9.16672 1.15414 9.16672 1.95828V5.70828C9.16672 6.51257 8.51257 7.16672 7.70828 7.16672ZM1.45828 1.75C1.34338 1.75 1.25 1.84338 1.25 1.95828V5.70828C1.25 5.82333 1.34338 5.91672 1.45828 5.91672H7.70828C7.82333 5.91672 7.91672 5.82333 7.91672 5.70828V1.95828C7.91672 1.84338 7.82333 1.75 7.70828 1.75H1.45828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70828 20.5002H1.45828C0.654144 20.5002 0 19.8461 0 19.0419V10.2919C0 9.48764 0.654144 8.8335 1.45828 8.8335H7.70828C8.51257 8.8335 9.16672 9.48764 9.16672 10.2919V19.0419C9.16672 19.8461 8.51257 20.5002 7.70828 20.5002ZM1.45828 10.0835C1.34338 10.0835 1.25 10.1769 1.25 10.2919V19.0419C1.25 19.1568 1.34338 19.2502 1.45828 19.2502H7.70828C7.82333 19.2502 7.91672 19.1568 7.91672 19.0419V10.2919C7.91672 10.1769 7.82333 10.0835 7.70828 10.0835H1.45828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417 20.5002H12.2917C11.4874 20.5002 10.8333 19.8461 10.8333 19.0419V15.2919C10.8333 14.4876 11.4874 13.8335 12.2917 13.8335H18.5417C19.3458 13.8335 20 14.4876 20 15.2919V19.0419C20 19.8461 19.3458 20.5002 18.5417 20.5002ZM12.2917 15.0835C12.1766 15.0835 12.0833 15.1769 12.0833 15.2919V19.0419C12.0833 19.1568 12.1766 19.2502 12.2917 19.2502H18.5417C18.6566 19.2502 18.75 19.1568 18.75 19.0419V15.2919C18.75 15.1769 18.6566 15.0835 18.5417 15.0835H12.2917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417 12.1667H12.2917C11.4874 12.1667 10.8333 11.5126 10.8333 10.7083V1.95828C10.8333 1.15414 11.4874 0.5 12.2917 0.5H18.5417C19.3458 0.5 20 1.15414 20 1.95828V10.7083C20 11.5126 19.3458 12.1667 18.5417 12.1667ZM12.2917 1.75C12.1766 1.75 12.0833 1.84338 12.0833 1.95828V10.7083C12.0833 10.8233 12.1766 10.9167 12.2917 10.9167H18.5417C18.6566 10.9167 18.75 10.8233 18.75 10.7083V1.95828C18.75 1.84338 18.6566 1.75 18.5417 1.75H12.2917Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_712_3530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboard-white.89e4f88edfa972f9591a079616397452.svg";
export { ForwardRef as ReactComponent };